/**
 * Labstep
 *
 * @module grid/Report/components/ToolPanel/Experiment
 * @desc Hardcoded list of columns for experiment fields
 */

import { ICONS } from 'labstep-web/constants/icons';
import { Flex } from 'labstep-web/core/Flex';
import { SectionHeader } from 'labstep-web/core/Header';
import {
  experimentAuthorColDef,
  experimentNameColDef,
  experimentWorkflowCreatedAtColDef,
  experimentWorkflowEndedAtColDef,
  experimentWorkflowEntityStateNameColDef,
  experimentWorkflowStartedAtColDef,
} from 'labstep-web/grid/Report/coldefs';
import { EntityDataGridToolPanelListItem } from 'labstep-web/grid/Report/components/ToolPanel/ListItem';
import { GridToolBarService } from 'labstep-web/grid/services/grid-toolbar.service';
import type React from 'react';
import type { IEntityDataGridToolPanelExperimentProps } from './types';

export const EntityDataGridToolPanelExperiment: React.FC<
  IEntityDataGridToolPanelExperimentProps
> = ({
  authenticatedUserEntity,
  gridReportService,
  searchQuery,
  colIds,
}) => (
  <Flex column>
    {GridToolBarService.showListSection(
      [
        'experiment name',
        'created by',
        'creation date',
        'started date',
        'completion date',
      ],
      searchQuery,
    ) && <SectionHeader label="Experiment Fields" />}
    {GridToolBarService.showListItem(
      'experiment name',
      searchQuery,
    ) && (
      <EntityDataGridToolPanelListItem
        icon="book"
        actionIcon="eye"
        text="Experiment Name"
        onClick={() => {
          gridReportService.addColumnDef(experimentNameColDef);
        }}
        disabled={
          experimentNameColDef.colId
            ? colIds.includes(experimentNameColDef.colId)
            : false
        }
      />
    )}
    {GridToolBarService.showListItem('created by', searchQuery) && (
      <EntityDataGridToolPanelListItem
        icon="user circle"
        actionIcon="eye"
        text="Created By"
        onClick={() => {
          gridReportService.addColumnDef(experimentAuthorColDef);
        }}
        disabled={
          experimentAuthorColDef.colId
            ? colIds.includes(experimentAuthorColDef.colId)
            : false
        }
      />
    )}
    {GridToolBarService.showListItem(
      'creation date',
      searchQuery,
    ) && (
      <EntityDataGridToolPanelListItem
        icon="calendar"
        actionIcon="eye"
        text="Creation Date"
        onClick={() => {
          gridReportService.addColumnDef(
            experimentWorkflowCreatedAtColDef,
          );
        }}
        disabled={
          experimentWorkflowCreatedAtColDef.colId
            ? colIds.includes(experimentWorkflowCreatedAtColDef.colId)
            : false
        }
      />
    )}
    {GridToolBarService.showListItem('started date', searchQuery) && (
      <EntityDataGridToolPanelListItem
        icon="calendar outline"
        actionIcon="eye"
        text="Started Date"
        onClick={() => {
          gridReportService.addColumnDef(
            experimentWorkflowStartedAtColDef,
          );
        }}
        disabled={
          experimentWorkflowStartedAtColDef.colId
            ? colIds.includes(experimentWorkflowStartedAtColDef.colId)
            : false
        }
      />
    )}
    {GridToolBarService.showListItem(
      'completion date',
      searchQuery,
    ) && (
      <EntityDataGridToolPanelListItem
        icon="calendar check outline"
        actionIcon="eye"
        text="Completion Date"
        onClick={() => {
          gridReportService.addColumnDef(
            experimentWorkflowEndedAtColDef,
          );
        }}
        disabled={
          experimentWorkflowEndedAtColDef.colId
            ? colIds.includes(experimentWorkflowEndedAtColDef.colId)
            : false
        }
      />
    )}
    {authenticatedUserEntity.hasFeatureEnabled(
      'signature_workflow',
    ) &&
      GridToolBarService.showListItem('status', searchQuery) && (
        <EntityDataGridToolPanelListItem
          icon={ICONS.entity_state_workflow.primary}
          actionIcon="eye"
          text="Status"
          onClick={() => {
            gridReportService.addColumnDef(
              experimentWorkflowEntityStateNameColDef,
            );
          }}
          disabled={
            experimentWorkflowEntityStateNameColDef.colId
              ? colIds.includes(
                  experimentWorkflowEntityStateNameColDef.colId,
                )
              : false
          }
        />
      )}
  </Flex>
);
